<template>
  <div class="w-100">
    <ReplyCreate
      :comment="comment"
      :show="replyCreate"
      @toggleReplyCreate="toggleReplyCreate"
      @replyCreated="replyCreated"
      class="mt-3"
    ></ReplyCreate>

    <div v-if="count">
      <div v-if="showReplies && comment.replies">
        <Reply
          v-for="reply in comment.replies"
          :key="reply.id"
          :comment="comment"
          :reply="reply"
          @replyCreated="replyCreated"
          @replyRemoved="replyRemoved"
          class="mt-3"
        ></Reply>
      </div>
      <div>
        <a href="#" class="" @click.prevent="toggleReplies">
          <span v-if="showReplies">{{ 'Hide' | translate}} {{'replies' | translate}}</span>
          <span v-else>{{ 'Show' | translate }} {{'replies' | translate}} ({{ comment.replies_count }})</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Reply from '~/player/components/Reply'
import ReplyCreate from '~/player/components/ReplyCreate'
import _ from 'lodash'

export default {
  components: {
    Reply,
    ReplyCreate,
  },
  props: ['comment'],
  data() {
    return {
      showReplies: false,
      replyCreate: false,
    }
  },
  computed: {
    count() {
      return this.comment.replies_count
    },
  },
  methods: {
    replyCreated(data) {
      this.$set(
        this.comment,
        'replies_count',
        _.get(this.comment, 'replies_count', 0) + 1,
      )

      if (this.showReplies) {
        return this.$set(this.comment, 'replies', [
          ..._.get(this, 'comment.replies', []),
          data,
        ])
      }
      this.getReplies()
      this.showReplies = true
    },
    toggleReplyCreate() {
      this.replyCreate = !this.replyCreate
    },
    toggleReplies() {
      if (!this.showReplies) {
        this.getReplies()
      }
      this.showReplies = !this.showReplies
    },
    replyRemoved(id) {
      this.$set(
        this.comment,
        'replies_count',
        _.get(this.comment, 'replies_count', 0) - 1,
      )
      this.$set(
        this.comment,
        'replies',
        _.get(this, 'comment.replies', []).filter((row) => row.id !== id),
      )
    },
    getReplies() {
      return this.$api.replies
        .index(this.comment.id)
        .then(({ data }) => {
          this.$set(this.comment, 'replies', data)
        })
        .catch((error) => {
          console.error(error)
        })
    },
  },
}
</script>

<style></style>
